import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { WebSocketService } from './services/websocket-service';

export const userGuard: CanActivateFn = () => {
  const webSocketService: WebSocketService = inject(WebSocketService);
  const router: Router = inject(Router);
  const clientIsConnected: boolean = webSocketService.client() !== undefined;
  if (clientIsConnected) return true;
  return router.createUrlTree(['/']);
};
